export default __webpack_public_path__ + "static/Screenshott-667b2948537cb6763d8c5c04cd042ba3.jpg";